import styled from 'styled-components'

export const Container = styled.div`
  width: 12px;
  min-width: 12px;
  max-width: 12px;
  min-height: 80px;
  background: transparent;
  border: 1px solid var(--border-neutral-default);
  border-radius: 8px; /* Border/Radius/MD */
  padding: 4px 0; /* Spacing/050 */
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  box-sizing: border-box;
  flex-shrink: 0;
  user-select: none;
  opacity: 1;
`

export const Track = styled.div`
  flex: 1;
  width: 100%;
  position: relative;
  cursor: pointer;
  background: transparent;
  border-radius: 4px;
  margin: 0 2px;

  &:hover {
    background: var(--color-gray-050);
  }
`

export const Thumb = styled.div`
  width: 6px;
  background: var(--color-gray-300);
  border-radius: 3px;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  cursor: grab;
  transition: background-color 0.2s;

  &:hover {
    background: var(--color-gray-400);
  }

  &:active {
    cursor: grabbing;
    background: var(--color-gray-500);
  }
`

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  width: 100%;
  margin-top: auto; /* Push to bottom if track doesn't fill? No, track is flex 1. */
`

export const ArrowButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--content-neutral-secondary);

  &:hover {
    color: var(--content-neutral-primary);
  }

  &:disabled {
    color: var(--content-disabled);
    cursor: default;
  }

  svg {
    font-size: 16px; /* Small icons */
  }
`
